import { Api, decryptApiResponse } from "../../../config/Api";
import { statusAndResponse } from "../../../util/requestHandler";
import axios from "axios";
import { getHttpConfigWithToken } from "../../../util/httpConfigWithToken";
import {
  decryptData,
  encryptData,
  generateNS,
} from "../../../config/encryptData";

export async function authenticate(request, nsHeader) {
  const encryptedRequest = await encryptData(request, nsHeader);

  const response = await axios.post(
    process.env.REACT_APP_BASE_URL + "/api/authenticate/pin",
    encryptedRequest,
    getHttpConfigWithToken({ "X-Session-Id": nsHeader }),
  );

  if (response.data?.err || response.data?.code) {
    return Promise.reject(response.data);
  }

  return response.data;
}

export async function requirePing(request, nsHeader) {
  const encryptedRequest = await encryptData(request, nsHeader);

  const response = await axios.post(
    process.env.REACT_APP_BASE_URL + "/api/authenticate",
    encryptedRequest,
    getHttpConfigWithToken({ "X-Session-Id": nsHeader }),
  );

  const data = response.data;

  if (data && data?.code && data?.code === 403) {
    return Promise.reject({ ...response.data, err: "Blocked" });
  }

  if (data && data?.code && data?.code === 406) {
    return Promise.reject({ ...response.data, err: "Not acceptable country" });
  }

  if (data?.err || data?.code) {
    return Promise.reject(response.data);
  }

  const valueDecrypted = await decryptData(
    JSON.parse(response.data.value),
    nsHeader,
  );

  return { ...response.data, value: valueDecrypted };
}

export async function passwordReset(email, nsHeader) {
  const encryptedRequest = await encryptData({ email }, nsHeader);
  const response = await axios.post(
    process.env.REACT_APP_BASE_URL + "/api/authenticate/reset",
    encryptedRequest,
    getHttpConfigWithToken({ "X-Session-Id": nsHeader }),
  );

  if (response.data?.err || response.data?.code) {
    return Promise.reject(response.data);
  }

  const valueDecrypted = await decryptData(
    JSON.parse(response.data.value),
    nsHeader,
  );

  return { ...response.data, value: valueDecrypted };
}
